<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-primary shadow-sm fixed-top">
    <div class="container-fluid">
      <button class="btn btn-link text-white" @click="$emit('toggle-sidebar')">
        <i class="fas fa-bars"></i>
      </button>

      <a class="navbar-brand ms-2" href="#">{{ this.$store.getters.appName }}</a>

      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ms-auto">
          <!--li class="nav-item">
            <a class="nav-link" href="#">
              <i class="fas fa-search"></i>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#">
              <i class="far fa-bell"></i>
              <span class="badge bg-danger rounded-pill">3</span>
            </a>
          </li-->
          <li class="nav-item dropdown" v-if="this.$store.getters.user && this.$store.getters.user.name">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown">
              <i class="fas fa-user me-1"></i>
              {{ this.$store.getters.user.name }}
            </a>
            <ul class="dropdown-menu dropdown-menu-end">
              <!--li><a class="dropdown-item" href="#">Profile</a></li>
              <li><a class="dropdown-item" href="#">Settings</a></li>
              <li><hr class="dropdown-divider"></li-->
              <li><a class="dropdown-item" href="#deconnexion" @click.prevent="logout()">
                  <i class="fas fa-sign-out-alt me-1"></i>
                  Logout
                </a></li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'NavBar',
  methods: {
    logout() {
      // Rediriger vers le tableau de bord
      if (this.$router.push({ name: 'login' })) {
        // Effacer les données utilisateur
        this.$store.commit('clearUserData')
      }
    }
  }
}
</script>

<style scoped>
.navbar {
  height: 56px;
  /* Fixez une hauteur */
  z-index: 1030;
  /* Important pour le overlay */
}
</style>